import React from 'react';
import SmallPrint from "./SmallPrint";

class DateField extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  render() {
    return (
      <div className="form-group">
        <label key={this.props.index} htmlFor={this.props.field.name + "_" + this.props.index}>
          {this.props.field.label}
        </label>
        <input className="form-control" id={this.props.field.name + "_" + this.props.index}
        type="date"
        defaultValue={this.props.field.value}
        name={this.props.field.name}
        required={this.props.field.required}
        autoComplete="off"
        ></input>
        <SmallPrint text={this.props.field.description}></SmallPrint>
      </div>
    );
  }
}
export default DateField;
